import * as user from "./services/user";
import * as login from "./services/login";
import * as authority from "./services/authority";
import * as student from "./services/student";


export default {
    ...user,
    ...login,
    ...authority,//权限相关
    ...student,//学生班级相关
}




// WEBPACK FOOTER //
// ./src/api/index.js